import React from 'react';

export const Card = ({ children, className = '', hover = false, glow = false, ...props }) => {
  return (
    <div
      className={`bg-white dark:bg-surface-800 rounded-2xl border border-gray-100 dark:border-white/[0.06] shadow-card dark:shadow-dark-card transition-all duration-300 ${
        hover ? 'hover:shadow-card-hover dark:hover:shadow-dark-card-hover hover:-translate-y-0.5' : ''
      } ${glow ? 'hover:border-brand-400/30 dark:hover:border-brand-400/20 hover:shadow-glow-sm' : ''} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export const CardContent = ({ children, className = '', ...props }) => {
  return (
    <div className={`p-5 ${className}`} {...props}>
      {children}
    </div>
  );
};

export const CardHeader = ({ title, subtitle, action, className = '', children, ...props }) => {
  return (
    <div className={`p-5 pb-0 ${className}`} {...props}>
      {children || (
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-base font-semibold text-gray-900 dark:text-white">{title}</h3>
            {subtitle && <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">{subtitle}</p>}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
    </div>
  );
};

export const CardFooter = ({ children, className = '', ...props }) => {
  return (
    <div className={`p-5 pt-0 ${className}`} {...props}>
      {children}
    </div>
  );
};

export const CardDescription = ({ children, className = '', ...props }) => {
  return (
    <p className={`text-sm text-gray-500 dark:text-gray-400 ${className}`} {...props}>
      {children}
    </p>
  );
};

export const CardTitle = ({ children, className = '', ...props }) => {
  return (
    <h3 className={`text-base font-semibold text-gray-900 dark:text-white ${className}`} {...props}>
      {children}
    </h3>
  );
};
